// Ensure we only initialize once per page load
if (!window.colorPickerInitialized) {
  document.addEventListener("turbo:load", function () {
    const partnerCustomColors = () => {
      const form = document.getElementById("brandSettingColorsForm");

      if (form !== null && !form.dataset.colorPickerInitialized) {
        form.dataset.colorPickerInitialized = "true";

        const swatches = ["#000", "#FFF", "#F00", "#0F0", "#00F"];

        // Wait a moment for the DOM to be fully ready
        setTimeout(() => {
          const inputs = [
            {
              pickrEl: document.getElementById("primaryColorPicker"),
              formEl: document.getElementById("partners_brand_setting_primary_color"),
            },
            {
              pickrEl: document.getElementById("secondaryColorPicker"),
              formEl: document.getElementById("partners_brand_setting_secondary_color"),
            },
            {
              pickrEl: document.getElementById("backgroundColorPicker"),
              formEl: document.getElementById("partners_brand_setting_background_color"),
            },
            {
              pickrEl: document.getElementById("emailHeaderBackgroundColorPicker"),
              formEl: document.getElementById("partners_brand_setting_email_header_background_color"),
            },
          ];

          inputs.forEach(function (input) {
            if (!input.pickrEl || !input.formEl) {
              console.error("Missing element for color picker", input);
              return;
            }

            try {
              const pickr = Pickr.create({
                theme: "classic",
                el: input.pickrEl,
                default: input.formEl.value || "#FFFFFF",
                swatches: swatches,
                components: {
                  preview: true,
                  hue: true,
                  interaction: {
                    hex: true,
                    rgba: true,
                    input: true,
                    clear: true,
                    save: true,
                  },
                },
              });

              input.formEl.onclick = () => {
                pickr.show();
              };

              pickr.on("clear", (instance) => {
                input.formEl.value = null;
              });

              // NOTE: This is a work-around to change the color box to an "X"
              //       when the user clicks 'clear'
              pickr.on("hide", (instance) => {
                setTimeout(() => {
                  if (input.formEl.value === "") {
                    instance.getRoot().button.style.removeProperty("--pcr-color");
                    instance.getRoot().button.style.color = "rgba(0, 0, 0, 0.15)";
                  }
                }, 1);
              });

              pickr.on("save", (e) => {
                const color = pickr.getColor().toHEXA().toString();
                input.formEl.value = color;
                pickr.hide();
              });
            } catch (error) {
              console.error("Error creating Pickr instance:", error, input);
            }
          });
        }, 100); // Small delay to ensure DOM is ready
      }
    };

    partnerCustomColors();
  });

  window.colorPickerInitialized = true;
}
